/* eslint-disable */
import { useState, useEffect, useContext, createRef } from "react";

// kendo react modules ==========================
import "@progress/kendo-theme-material/dist/all.css";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
// impoting excel colums
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { Link } from "react-router-dom";

const MaterialKitList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");

  const {
    reloadMaterialList,
    setReloadMaterialList,
    setEditMaterialData,
    screenHeight,
  } = useContext(GlobalProvider);

  // default user data ------------------------------------
  const [materialData, setMaterialData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);

  // without pagination ------------------------------------
  const initialDataState = {};
  const [dataState, setDataState] = useState();
  const [result, setResult] = useState(process(materialData, initialDataState));

  const onDataStateChange = (event) => {
    console.log("event -->", event);
    setDataState(event.dataState);
    setResult(process(materialData, event.dataState));
  };

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const _exporter = createRef();
  const exportExcel = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  /* function to search */
  const filterData = () => {
    if (!result || !result.data) {
      return []; // Return an empty array if result or result.data is undefined
    }

    const filteredData = result.data.filter((item) => {
      const name = item?.name?.toLowerCase() || "";
      const unitsperday = item?.unitsperday?.toLowerCase() || "";
      const unitspercourse = item?.unitspercourse?.toLowerCase() || "";

      const date = item?.materialkitdate;

      return (
        (name && name.includes(search.toLowerCase())) ||
        (unitsperday && unitsperday.includes(search.toLowerCase())) ||
        (unitspercourse && unitspercourse.includes(search.toLowerCase())) ||
        (date && date.includes(search))
      );
    });
    setRecords(filteredData.length);
    return filteredData;
  };

  // check the selected count and show the count in top and also selected download xls ------------------------
  const handelSelectedCount = () => {
    let checkboxes = document.querySelectorAll('input[name="selectRecord"]');

    let totalSelected = 0;
    let filteredData = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        totalSelected++;
        const filteredUser = materialData.find(
          (user) => user._id === checkbox.value
        );
        filteredUser && filteredData.push(filteredUser);
      }
    });

    // Update the content of the block
    checkedRecordCount(totalSelected);
    return filteredData;
  };

  // mark all checkbox as selected ----------------
  const selectAllRecords = (e) => {
    document
      .querySelectorAll('.k-master-row input[name="selectMaterialRecord"]')
      .forEach((checkbox) => {
        checkbox.checked = e.target.checked;
      });
    handelSelectedCount();
  };

  // blocks to replace the Grid HTML ==============================================
  const SelectRecordHeader = () => {
    return (
      <div className="d-flex align-items-center">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="selectAllMain"
            onClick={selectAllRecords}
          />
        </div>
      </div>
    );
  };

  /* Select single row */
  const SelectRecordRow = (props) => {
    return (
      <td>
        <div className="form-check">
          <input
            className="form-check-input "
            type="checkbox"
            value={props.dataItem._id}
            name="selectMaterialRecord"
            onClick={handelSelectedCount}
          />
        </div>
      </td>
    );
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <td className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.name}</span>

          {/* ------ edit icon start ------ */}
          <Link
            to="#saveMaterialPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditMaterialData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
          {/* ------ edit icon end ------ */}

          {/* -------------- calendar icon start ------------- */}
          <Link
            to={"/materialcalendar/" + dataItem._id}
            className="icon-btn edit_icon"
            role="button"
          >
            <span className="d-block material-symbols-outlined">
              calendar_month
            </span>
          </Link>
          {/* -------------- calendar icon end ------------- */}
        </div>
      </td>
    );
  };

  //function for get all data
  const getAllData = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_MATERIAL_KIT + `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(`Material kit response`, response);
      if (response.status) {
        setMaterialData(response.data);
        setResponseReceived(true);

        dataState
          ? setResult(process(response.data, dataState))
          : setResult(process(response.data, initialDataState));
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (reloadMaterialList) {
      getAllData();
      setResult(process(materialData, initialDataState));
      setReloadMaterialList(false);
    }
  }, [reloadMaterialList]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllData();
    }
  }, [responseReceived]);

  /* hook to hit  exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* hook to hit filterData function on search */
  useEffect(() => {
    filterData();
  }, [search]);

  /* set records based on onDataStateChange */
  useEffect(() => {
    setRecords(result.data.length);
  }, [result]);

  return (
    <div className="activity_table">
      <div className="table-responsive">
        {/* ============ download xls start ========== */}
        <ExcelExport
          data={
            handelSelectedCount().length > 0
              ? handelSelectedCount()
              : materialData
          }
          fileName="Material Kit.xlsx"
          ref={_exporter}
        >
          <ExcelExportColumn field="name" title={t("Name")} />
          <ExcelExportColumn
            field="unitsperday"
            title={t("Unit Available Per Day")}
          />
          {/* <ExcelExportColumn
            field="unitspercourse"
            title={t("Units Available Per Course")}
          /> */}
          <ExcelExportColumn field="materialkitdate" title={t("Date")} />
        </ExcelExport>

        {/* ============ download xls end ========== */}
        {search ? (
          <Grid
            style={{ height: screenHeight }}
            data={filterData()}
            filterable={true}
            sortable={true}
            groupable={true}
            onDataStateChange={onDataStateChange}
            {...dataState}
            //pageable = {true}
            //total = {products.length}
            reorderable
            // resizable
          >
            <GridColumn
              field="id"
              headerCell={SelectRecordHeader}
              cell={SelectRecordRow}
              filterable={false}
              sortable={false}
              width="70px"
            />

            <GridColumn
              field="name"
              title={t("Name")}
              cell={nameHTML}
              //width="200px"
            />
            <GridColumn
              field="unitsperday"
              title={t("Unit Available Per Day")}
              //width="200px"
            />
            {/* <GridColumn
              field="unitspercourse"
              title={t("Units Available Per Course")}
            /> */}
            <GridColumn
              field="materialkitdate"
              title={t("Date")}
              //width="200px"
            />
          </Grid>
        ) : (
          <Grid
            style={{ height: screenHeight }}
            data={result}
            filterable={true}
            sortable={true}
            groupable={true}
            onDataStateChange={onDataStateChange}
            {...dataState}
            //pageable = {true}
            //total = {products.length}
            reorderable
            // resizable
          >
            <GridColumn
              field="id"
              headerCell={SelectRecordHeader}
              cell={SelectRecordRow}
              filterable={false}
              sortable={false}
              width="70px"
            />

            <GridColumn
              field="name"
              title={t("Name")}
              cell={nameHTML}
              //width="200px"
            />
            <GridColumn
              field="unitsperday"
              title={t("Unit Available Per Day")}
              //width="200px"
            />
            {/* <GridColumn
              field="unitspercourse"
              title={t("Units Available Per Course")}
            /> */}
            <GridColumn
              field="materialkitdate"
              title={t("Date")}
              //width="200px"
            />
          </Grid>
        )}
      </div>
    </div>
  );
};

export default MaterialKitList;
